export default {
  modalTitle: {
    id: 'merchants_feedback_modal_title',
    defaultMessage: 'Give us your feedback!',
  },
  modalSubtitle: {
    id: 'merchants_feedback_modal_subtitle',
    defaultMessage: 'Let us know what you think of this feature.',
  },
  sendFeedbackButton: {
    id: 'merchants_feedback_modal_send_feedback_button',
    defaultMessage: 'Send feedback',
  },
  notNowButton: {
    id: 'merchants_feedback_modal_not_now_button',
    defaultMessage: 'Not now',
  },
  altLabel: {
    id: 'merchants_feedback_modal_alt_label',
    defaultMessage: 'Give your feedback!',
  },
}
